import React from "react"
export default function Hero() {
  return (
    <header>
      <nav>
        <ul>
          <li className="nv1">
            <a href="#who-we-are">qui somme nous?</a>
          </li>
          <li className="nv2">
            <a href="#our-product">nos produit</a>
          </li>
          <li className="nv1">
            <a href="#our-team">notre équipe</a>
          </li>
          <li className="nv2">
            <a href="#">contact</a>
          </li>
        </ul>
      </nav>
    </header>
  )
}
